import { render, staticRenderFns } from "./MouldingOptions.vue?vue&type=template&id=a1466544&lang=pug"
import script from "./MouldingOptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./MouldingOptions.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports